/**
 * date-utils.ts — Utilidades para normalización y formateo de fechas
 * Evita desvíos por zona horaria local al trabajar con fechas UTC sin hora.
 */

export interface UTCDateComponents {
  year: number;
  month: number; // 1-indexed (1-12)
  day: number;   // 1-31
  formattedDate: string; // YYYY-MM-DD
}

/**
 * Extrae los componentes de una fecha en formato UTC, evitando corrimientos locales.
 */
export function getUTCDateComponents(dateInput: string | Date): UTCDateComponents {
  const d = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  const year = d.getUTCFullYear();
  const month = d.getUTCMonth() + 1;
  const day = d.getUTCDate();

  const monthStr = String(month).padStart(2, '0');
  const dayStr = String(day).padStart(2, '0');

  return {
    year,
    month,
    day,
    formattedDate: `${year}-${monthStr}-${dayStr}`
  };
}

/**
 * Formatea una fecha UTC al formato legible DD/MM/YYYY.
 */
export function formatUTCDate(dateInput: string | Date): string {
  const { day, month, year } = getUTCDateComponents(dateInput);
  const dayStr = String(day).padStart(2, '0');
  const monthStr = String(month).padStart(2, '0');
  return `${dayStr}/${monthStr}/${year}`;
}
